import { render, staticRenderFns } from "./DescribeObjectStore.vue?vue&type=template&id=526ebf70"
import script from "./DescribeObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./DescribeObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports